module.exports = __webpack_public_path__ + "static/img/tree.219af8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tree.png
// module id = e536251f6a6c281b
// module chunks = 59